import { render, staticRenderFns } from "./PlanCrud.vue?vue&type=template&id=1470e02e&scoped=true"
import script from "./PlanCrud.vue?vue&type=script&lang=js"
export * from "./PlanCrud.vue?vue&type=script&lang=js"
import style0 from "./PlanCrud.vue?vue&type=style&index=0&id=1470e02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470e02e",
  null
  
)

export default component.exports